
import { bl_dgmkt_project_segment_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectSegmentLinkContainerModel extends BaseContainerModel {
  bl_dgmkt_project_segment_link: bl_dgmkt_project_segment_link_RowClass = new bl_dgmkt_project_segment_link_RowClass();
}
